<style>
    * {
        all: revert;
    }
</style>

<script lang="ts">
    import { _ } from 'svelte-i18n';

    import SelectInput, {
        OptionType
    } from '@eqs/cms-svelte-irtools/form/components/SelectInput.svelte';
    import { TextInputSvelte } from '@eqs/cms-svelte-irtools/form/components';
    import CheckBoxInput from '@eqs/cms-svelte-irtools/form/components/CheckboxInput.svelte';
    import {
        combineValidates,
        email as emailValidator,
        required
    } from '@eqs/cms-svelte-irtools/form';
    import type { PersonInfoType } from '../utils/types';
    import type { ValidateFunction } from '@eqs/cms-svelte-irtools/form';

    export let data: PersonInfoType;
    export let distributionList: string[] = [];
    export let supportedDist: string[] = [];
    let inputError: { [key: string]: undefined | string } = {};

    const LanguageOptions: OptionType[] = [
        { name: $_('dropdown_options.salutation.en'), value: 'en' },
        // { name: $_('dropdown_options.salutation.de'), value: 'de' },
        { name: $_('dropdown_options.salutation.zh_s'), value: 'zh-Hans' }
    ];

    const affiliationOptions: OptionType[] = [
        {
            name: $_('dropdown_options.affiliation.private_investor'),
            value: 'Private_Investor'
        },
        {
            name: $_('dropdown_options.affiliation.institutional_investor'),
            value: 'Institutional_Investor'
        },
        { name: $_('dropdown_options.affiliation.analyst'), value: 'Analyst' },
        {
            name: $_('dropdown_options.affiliation.journalist'),
            value: 'Journalist'
        },
        { name: $_('dropdown_options.affiliation.other'), value: 'Other' }
    ];
    const affiliationToDLMap: { [key: string]: string } = {
        Private_Investor: 'private-investor',
        Institutional_Investor: 'institutional-investor',
        Analyst: 'analyst',
        Journalist: 'journalist',
        Other: 'other'
    };

    supportedDist = ['website-subscribers'];

    $: {
        if (data.affiliation) {
            distributionList = ['website-subscribers'];
        }
    }

    const validates: { [key: string]: ValidateFunction } = {};
    export const validate: ValidateFunction = async () => {
        await combineValidates(...Object.values(validates))();
    };
</script>

<div class="eqs-form-main">
    <div class="eqs-form-feild">
        <TextInputSvelte
            bind:value="{data.firstName}"
            containerCssClass="textInputBox"
            label="{$_('contact_form.labels.first_name')}"
        />
    </div>

    <div class="eqs-form-feild">
        <TextInputSvelte
            bind:value="{data.lastName}"
            containerCssClass="textInputBox"
            label="{$_('contact_form.labels.last_name')}"
        />
    </div>
    <div class="eqs-form-feild">
        <TextInputSvelte
            bind:value="{data.email}"
            containerCssClass="textInputBox"
            type="email"
            label="{$_('contact_form.labels.email')} *"
            validators="{[
                required(
                    $_('generic.validation.required', {
                        values: { field: 'email' }
                    })
                )
            ]}"
            bind:validate="{validates.email}"
            bind:error="{inputError.email}"
            cssClass="{inputError.email ? 'error' : ''}"
        />
    </div>
    <div class="eqs-form-feild">
        <TextInputSvelte
            bind:value="{data.company}"
            containerCssClass="textInputBox"
            label="{$_('contact_form.labels.company')}"
        />
    </div>
    <div class="eqs-form-feild">
        <SelectInput
            bind:value="{data.otherLocales}"
            containerCssClass="selectBox"
            label="{$_('contact_form.labels.language')}"
            placeholder="{$_('generic.prompts.please_choose')}"
            options="{LanguageOptions}"
        />
    </div>
    <div class="eqs-form-feild">
        <CheckBoxInput
            bind:checked="{data.privacy}"
            containerCssClass="checkBox"
            type="checkbox"
            label="{$_('contact_form.labels.privacy_text')} *"
            validators="{[required($_('generic.validation.privacy_required'))]}"
            bind:validate="{validates.privacy}"
        />
    </div>
</div>
